"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WirelessCartSummaryCms = void 0;
var WirelessCartSummaryCms = /** @class */ (function () {
    function WirelessCartSummaryCms() {
        this.customerCampaignReminderMsg = 'Use code <span> {0} </span> to get your discount';
        this.customerCampaignBenefitDetail = 'Be sure to apply promo code <span> {0} </span> to get a discount on your eligible items!';
        this.accessFeeHelpLink = 'What\'s this';
        this.accessFeeHelpModalHeading = 'Device access charge';
        this.accessFeeHelpModalLine1 = 'The device access charge is the monthly cost to use this device on your plan';
        this.accessFeeHelpModalLine2 = 'Your monthly access charge is based on the type of device (such as smartphone or tablet)' +
            ' and, if it\'s a smartphone, also by the contract status';
        this.accessFeeHelpModalLine3 = 'This charge should appear on your bill as' +
            ' <b>Access for Smartphone 4G LTE w/ VVm</b> or something similar';
        this.activationFee = 'Activation Fee per line (due on 1st bill)';
        this.activationFeeWaiver = '$0 activation fee for online orders';
        this.capacityEditModalFooter = 'See updated price in cart after selection.';
        this.capacityEditModalHeader = 'CHANGE CAPACITY';
        this.cancelButtonLabel = 'Cancel';
        this.crpLegalMsgHeader = 'Changes to your plan start {0}.';
        this.crpLegalMsgContent = 'On your next bill, you may see a partial-month credit for the remaining days of your current plan. You may also see partial-month charges for your new plan, plus full plan charges for a month in advance.';
        this.deviceAccessCharge1 = 'Includes $ {0} Device Access Charge';
        this.deviceAccessCharge2 = 'Includes $ {0} in access charges for {1} devices';
        this.abpDiscountLable = 'AutoPay and paperless billing discount for {0} phone(s). Discount starts within 2 bill periods.';
        this.mixAndMatchAbpDiscountLable = 'AutoPay and paperless billing discount. Starts within 2 bill periods.';
        this.due1stBillModalHeading = 'Monthly & one-time charges on first bill';
        this.dueMonthlyAmountMsgPt1 = ', keep ';
        this.dueMonthlyAmountMsgPt2 = 'Keep ';
        this.dueMonthlyAmountMsgPt3 = "in mind that the due monthly amount is for this order only. It doesn't include\n   charges for any of your existing services";
        this.dueMonthlyLabel = 'Due monthly';
        this.memberOfferHeading = 'Member offer:';
        this.titleATTFees = 'AT&T Administrative & Regulatory Cost Recovery Fees';
        this.feesAmtSubTextLabel = '{0}/mo. per line';
        this.tradeinHeading = 'Your trade-in';
        this.tradeinEdit = 'Edit';
        this.noTradeinHeading = 'Trade in and save';
        this.notradeinRewardHeading = 'Trade in a device';
        this.tradeinButton = 'Trade in a device';
        this.tradeinRewardButton = 'Trade in';
        this.noTradeinButton = 'No, thanks';
        this.noTradeinRewardsButton = 'Don’t trade in';
        this.tradeinLegalSubHeading = 'Save up to ${0} when you trade in an eligible device.';
        this.tradeinEstimatedText = 'Estimated promotional value: ';
        this.tradeinDifferentDevice = 'Trade in a different device';
        this.tradeinLegal = "Limited Time. Requires new line or upgrade of existing line, unlimited plan (speed restr's apply),\n                   and trade-in of eligible smartphone. Price after up to ${0} in credits over 36 mos.";
        this.tradeinRewardLegal = "You can use the value of your eligible trade-in to pay your bill or make purchases\n                         at AT&T stores and att.com";
        this.tradeinSubHeading = 'Get monthly bill credits toward your new device.';
        this.tradeinRewardSubHeading = "What do you plan on doing with your previous device? It could be worth up to\n                              $200 in value! ";
        this.tradeinSubHeadingLink = 'See how trade-in works';
        this.tradeinSeeDetailsLink = 'See offer details';
        this.tradeinRewardsSeeDetailsLink = ' See details & trade-in values';
        this.tradeinAccept = 'Trade in the device';
        this.tradeinModalHeading = 'How to complete a trade-in';
        this.tradeinInfoBox = "<p><b>1. Buy a new smartphone</b></p><p>Select the trade-in option after you pick your new device.\n  </p><p><b>2. Send us your trade-in</b></p><p>Returning your trade-in device is easy! You\u2019ll select how you\u2019d like to\n   do it at checkout. Be sure to send us your trade-in within 30 days of activating your new device. Here\u2019s how you can\n    return your trade-in.<ul><li>Request a return kit</li><li>Print your own return label</li><li>Drop it off at an\n     AT&T store</li><li>Give it to your AT&T Right To You expert (as available)</li></ul></p><p><b>3. Receive your\n      trade-in credits</b></p><p>If you\u2019re trading in for an AT&T device offer, monthly credits will usually begin in\n       2-3 bill periods. This is after your old device has been received and verified. For trade-ins without an offer,\n        you\u2019ll receive an AT&T promotional card for the value of your device.</p>";
        this.firstNetLine = "<b>FirstNet</b>";
        this.aalModalHeading = "Add your next line";
        this.aalModalMemberText = "Who will use this line?";
        this.aalTab1Heading = "Family or friends";
        this.aalTab2Heading = "Me";
        this.aalTab1Copy = "Which type of device you want to add?";
        this.aalTab2Copy = "You can have one phone, one tablet, one smartwatch, and one hotspot on the FirstNet network. ";
        this.aalSubmitBtnText = "Continue";
        this.changeCapacityWarrningMsg = "<b>Heads up:</b> If you choose this capacity, {0} will be " + 1 + " per month.";
        this.updatedPriceWarningMsg = "When you're done, we'll show your updated prices in the cart.";
        this.dueTodayPrepaidLegal = '/ecms/sharedcontent/en/legal/ipd-platform/sales/buy/wireless/duemthlychargesprepaid/' +
            '_jcr_content/desktoplegal/legalsharedcontent.json';
        this.IruDueMonthlyLegal = "/ecms/sharedcontent/en/legal/ipd-platform/sales/buy/cart/iruduemonthlylegal\n  /_jcr_content/desktoplegal/legalsharedcontent.json";
        this.dueMonthlyModalHeading = 'Monthly & one-time charges';
        this.changePlanOfferLabel = "<b>Heads up:</b> If you buy a device with an offer that requires an Unlimited plan,\n    you must change your plan within 14 days to keep the price shown. After you place your order,\n     go to myAT&T to change your plan.";
        this.crpLaterLabelInfo = "Don't miss out! You can still qualify for a monthly device discount. Just be sure to upgrade to an Unlimited plan within 14 days of activating your new device by going to myAT&T.";
        this.crpLaterUpgradeMessage = "Upgrade to an eligible unlimited plan (speed restr\u2019s apply) within 14 days to pay $(0)/mo.; otherwise, your device price will be $(1)/mo. Don't want an unlimited plan? You can remove your trade-in below, and we'll update your device price.";
        this.dueMonthlyCrpLaterMessage = "Upgrade to an eligible unlimited plan (speed restr\u2019s apply) within 14 days to pay $(0)/mo.; otherwise, your device price will be <b>$(1)/mo</b>.";
        this.autoBillPayHeading = 'AutoPay and paperless billing';
        this.autoBillPayDetails = "Get a $10/mo. discount (starts within 2 bills) per phone line when you sign up for paperless billing and AutoPay with a debit card or bank account. Or $5/mo. with a credit card.";
        this.noAutoBillPay = 'No, thanks';
        this.autoBillPayText = 'I want AutoPay and paperless billing';
        this.preSelectedAutoPayText = 'Sign up at checkout to get your discount.';
        this.nonPreSelectedAutoPayText = "Don't miss out! You'll still have a chance at checkout to sign up and save.";
        this.zipChangeOKLabel = 'OK';
        this.moreInsuranceOptions = 'Your ZIP Code changed';
        this.moreInsuranceOptionsLog = "Our device protection plans vary by state. To see which other options are available for the ZIP Code you provided, sign in to your myAT&T account within 30 days of activating your new device.";
        this.govTaxAndFeeIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2009c/legalmodal/offers/wireline/cart/govtaxandfeeslm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: 'Government taxes and additional AT&amp;T fees extra.',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.dueMonthlyLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/seasonalsubscriptionslm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: '<p>These services auto-renew, unless otherwise noted, every season unless you call to cancel.</p>\n<p>&nbsp;</p>\n',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.dueMonthlyPrepaidLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/seasonalsubscriptionslm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: '<p>These services auto-renew, unless otherwise noted, every season unless you call to cancel.</p>\n<p>&nbsp;</p>\n',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.iruDueMonthlyLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/seasonalsubscriptionslm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: '<p>These services auto-renew, unless otherwise noted, every season unless you call to cancel.</p>\n<p>&nbsp;</p>\n',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.dueTodayLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/seasonalsubscriptionslm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: '<p>These services auto-renew, unless otherwise noted, every season unless you call to cancel.</p>\n<p>&nbsp;</p>\n',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.dueTodayPrepaidLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2101b/legalmodal/offers/wireline/cart/duetodaychargesprepaidlm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: 'Due today',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.iruDueTodayLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/seasonalsubscriptionslm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: '<p>These services auto-renew, unless otherwise noted, every season unless you call to cancel.</p>\n<p>&nbsp;</p>\n',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.dueOnFirstBillLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/seasonalsubscriptionslm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: '<p>These services auto-renew, unless otherwise noted, every season unless you call to cancel.</p>\n<p>&nbsp;</p>\n',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.iruDueOnFirstBillLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/seasonalsubscriptionslm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: '<p>These services auto-renew, unless otherwise noted, every season unless you call to cancel.</p>\n<p>&nbsp;</p>\n',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.smbDueTodayLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2008a/legalmodal/offers/wireline/cart/duetodaychargessmblm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: 'Due today',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.smbDueOnFirstBillLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2008a/legalmodal/offers/wireline/cart/dueon1stbillsmblm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: 'Due on 1st bill',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.externalOrderSourceOnFirstBillLegal = {
            legalModalPath: [
                '/idpassets/fragment/legal/2008a/legalmodal/offers/wireline/cart/dueon1stbillsmblm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: "*Plus add'l taxes and fees. Amounts shown are for this order only and don't include current account charges.",
                shortLegalLinkLabel: 'See details',
            },
        };
        this.dueTodayModalHeading = 'Due-today charges';
        this.estimatedSalesTax = 'Estimated sales tax';
        this.estimatedSalesEquipmentTax = 'Estimated sales tax on equipment';
        this.estimatedSalesPlanTax = 'Estimated taxes & fees on plan';
        this.equipmentTaxToolTip1 = "This is only an estimated total of sales tax on any device, SIM card, or accessory in your cart. We've estimated your sales tax based on your shopping";
        this.equipmentTaxToolTip2 = " ZIP Code. At checkout, actual sales tax may vary and is based on your shipping ZIP Code or the ZIP Code of the AT&T store where your";
        this.equipmentTaxToolTip = "" + this.equipmentTaxToolTip1 + this.equipmentTaxToolTip2 + " items will be picked up (if available).";
        this.prepaidPlanTaxToolTip = "We\u2019ll calculate the taxes and fees on your selected plan after you've added your payment method at checkout.";
        this.autopayPlanLabel = 'For plans enrolled in AutoPay';
        this.bsseEstimatedSalesTax = 'Estimated taxes & fees';
        this.lineOneTimeSalesTaxLabel = 'Estimated one-time sales tax';
        this.lineOneTimeSalesTaxToolTip = "This is an estimate of your one-time sales tax. Actual tax may vary and will be calculated at checkout.\n   Tax on your wireless equipment is based on your shipping ZIP Code or the ZIP Code of the AT&T store where your items will be picked up (if available).\n    Keep in mind that this includes tax on the full price of a device on an installment plan. Tax on your one-time charges,\n     such as an activation or upgrade fee, is based on the place of primary use address for each line.This is an estimate of your one-time sales tax.\n      Actual tax may vary and will be calculated at checkout. Tax on your wireless equipment is based on your shipping ZIP Code or the ZIP Code of the\n       AT&T store where your items will be picked up (if available). Keep in mind that this includes tax on the full price of a device on an installment plan.\n        Tax on your one-time charges, such as an activation or upgrade fee, is based on the place of primary use address for each line.";
        this.shareFeatureLabel = 'Device Access Charge';
        this.lineLabel = 'Line';
        this.lineAALLabel = 'New Line';
        this.lineEAPLabel = 'YOUR DEVICE';
        this.downPaymentLabel = 'Required down payment';
        this.twoYearContract = '2-year contract';
        this.upgradeLine = 'Upgrade a different line';
        this.advancePaymentLabel = 'Required advance payment';
        this.monthlyPayments = 'monthly payments';
        this.monthlyPaymentsWithAPRLabel = 'mos., 0% APR';
        this.noAnnualContractLabel = 'No annual contract';
        this.planLineHeading = 'Plan';
        this.byodPlanLineHeading = 'AT&T PREPAID';
        this.byodPaymentHeading = 'Payment for plan';
        this.byodAutoPayTip = "You'll be able to set up AutoPay after you've received  your order at att.com/myprepaid.";
        this.byodPaymenttoolTip = "By paying your first month's service today. we'll include an AT&T PREPAID Refill Card\n   with your order. You'll apply the total value of the card, the amount you're paying today,to\n    your account. You'll be able to set up AutoPay after you've received  your order at att.com/myprepaid.\n    Don't want to pay today? You can remove the refill card(hit the \"Edit\" link above) and make a payment\n    when you're ready to activate your plan. ";
        this.byodUsagePlanLabel = 'Based on usage';
        this.removeButtonLabel = 'Remove';
        this.removeModalContent = 'Sure you want to remove this?';
        this.removeModalHeading = 'Remove from cart';
        this.bsseServicePeriodLabel = "For service from {0} \u2013 {1}. Your AutoPay due date and the start of your bill period will be the {2} of each month";
        this.bsseIncludeTaxLabel = "Includes sales tax of {0}";
        this.commonCartLegalLabel = '*Includes estimated taxes and fees.';
        this.bsseActivationFeeLabel = "Activation fee (one-time charge)";
        this.bsseOneTimeLabel = "One-time charges";
        this.bsseOneTimeCreditLabel = 'One-time credit for current line(s)';
        this.bsseCreditSubLabel = 'Credit from {0} – {1}. Your monthly plan price for your existing lines will go down with today’s order';
        this.bsseSavingsLinkText = 'See your savings';
        this.dueTodayMonthlyLabel = 'Monthly Charges';
        this.dueTodayPartialMonthlyLabel = 'Monthly charges (partial month)';
        this.alCommonCartLegalLabel = "*Includes estimated taxes and fees. Amounts shown are for this order only and don't include current account charges.";
        this.fullRetailPriceLabel = "Full retail price";
        this.addAnotherLineLabel = "Add another line";
        this.monthlyChargesLabel = "Estimated monthly surcharges, fees, and taxes";
        this.monthlyChargesLinkLabel = "See cost breakdown";
        this.monthlyChargesModalTitle = "Monthly surcharges, fees, and taxes";
        this.monthlyChargesModalSubTitle = "Here's a breakdown of your estimated monthly surcharges, fees,\n and taxes. For more details, go to att.com/mobilityfees.";
        this.monthlyChargesModalFooterLabel = "The amounts are estimates and are based on the primary place of use (PPU) address per line.\n Your PPU address is defaulted to your billing address, but you can change it later by signing in to your myAT&T account.";
        this.monthlyChargesSurchargesLabel = "Surcharges & fees";
        this.monthlyChargesTaxesLabel = "Government taxes & fees";
        this.universalSimLabel = "AT&T Universal SIM";
        this.yourDeviceTextLabel = "Your device:";
        this.imeiNumberLabel = "IMEI:";
        this.rtiCommonDeliveryText = '<b>Get your order as soon as today!</b> Check eligibility at checkout.';
        this.rtiOOSMessage = '<b> One or more items in your cart are now out of stock.</b> Look for the alerts and follow the steps to complete your cart.';
        this.rtiC2SCartLevelText = '<b> One or more items in your cart are no longer available for shipping.</b> Look for the alerts to see which item(s) can’t be shipped.';
        this.noRtiCommonDeliveryMessage = "<b>Your entire order must either be shipped or picked up at a store.</b> Look for the alerts to determine how you\u2019d like to update your order.\n  You can either remove some items or edit your selections.";
        this.rtiShippingText = 'This item can only be shipped.';
        this.rtiC2Stext = 'This item can’t be shipped. See other delivery options at checkout.';
        this.rtiPickupText = 'This item can only be picked up in store.';
        this.removeItemLabel = 'remove this item';
        this.pickAccessoryLabel = 'pick a different accessory';
        this.removeDeviceLabel = 'remove this device';
        this.pickDeviceLabel = 'pick a different device';
        this.editDeviceLabel = 'edit your selection';
        this.deviceOOSText1 = "<b> This item is out of stock. </b> You can {0}";
        this.deviceOOSText = "<b> This item is out of stock. </b> You\u2019ll have to {0} from your order.";
        this.konaESimCapable = 'eSIM activation';
        this.konaPhysicalSim = 'AT&T Universal SIM Card';
        this.konaDeviceESimCapable = 'eSIM activation';
        this.accessoryOOSText = '<b> Stock is now limited for this item.</b> Please remove {0} of these items from your cart';
        this.bsseTaxApiUp = "This is an estimate of your monthly taxes and fees for this line. Each line includes a\n   Regulatory Cost Recovery Fee (up to $1.50), an Administrative Fee ($1.99), other AT&T fees which are\n    not government-required surcharges, and monthly taxes. For more details, go to att.com/mobilityfees.";
        this.taxApiUp = "Estimated sales tax on your wireless equipment is based on the shopping ZIP Code you provided\n     earlier. Actual sales tax may vary and is based on your shipping ZIP Code or the ZIP Code of the AT&T store\n     where your items will be picked up (if available).";
        this.taxApiDown = "Sales taxes will be calculated after you submit your order. We'll include them on your\n     confirmation email.";
        this.taxEstimated = "This is only an estimated total of sales tax on any device, SIM card, or accessory in your cart.\n      The actual amount, including tax on your plan, will be shown after you've added your payment info at checkout.";
        this.taxNotCalculatedSubText = '(Calculated at checkout)';
        this.lineOfBusinessName = 'Wireless';
        this.removeItemsLinkLabel = 'Remove wireless';
        this.deviceCountOneLabel = 'For 1 device';
        this.deviceCountLabel = 'For {0} devices';
        this.priceBreakdownModalLink = 'See price details with discounts';
        this.preOwnedDeviceLabel = '[Certified Pre-owned]';
        this.billCreditLabel = 'Bill credit to be applied over {0} mos.';
        this.downPaymentAndBillCreditLabel = "Price for {0} mos. at 0% APR after {1} down payment & {2}/mo. bill credit";
        this.noDownPaymentAndBillCreditLabel = "Price for {0} mos. at 0% APR";
        this.billCreditPositiveAmountAprLabel = "Price for {0} mos. at 0% APR after {1}/mo. bill credit";
        this.billCreditNegativeAmountAprLabel = "Price for {0} mos. at 0% APR after {1} down payment & {2}/mo. bill credit. ";
        this.billCreditNegativeAmountLink = "See pricing details ";
        this.yourDeviceLabel = "Your {0} pricing ";
        this.yourDeviceSubLabel = "Here\u2019s how we calculated the monthly price you\u2019ll pay, based on your required down payment and any other choices you made.";
        this.yourDeviceRetailLabel = "{0} (retail price)";
        this.hylaTradeinOfferLabel = 'Estimated promotional trade-in value credits*';
        this.hylaTradeinPortinOfferLabel = 'Estimated promotional trade-in value + number transfer credits*';
        this.hylaTradeinBogoOfferLabel = 'Device offer + estimated promotional trade-in value credits*';
        this.hylaTradeinPortinBogoOfferLabel = 'Device offer + estimated promotional trade-in value + number transfer credits*';
        this.bogoOfferLabel = 'Device offer credits';
        this.remainingBalanceLabel = 'Remaining balance';
        this.totalMonthlyLabel = 'Total monthly price';
        this.totalMonthlySubLabel = 'Your remaining balance will be applied as a {0}/mo. credit over {1} months.';
        this.downPaymentOnlyLable = "Price for {0} mos. at 0% APR after {1} down payment";
        this.externalOrderSourceLegalLabel = "*Plus add'l taxes and fees. Amounts shown are for this order only and don't include current account charges.";
        this.externalOrderSourceHeadingLabel = "NumberSync for Connected Car";
        this.externalOrderSourceNameLabel = "Sync with";
        this.chooseDevice = "Choose a new device ";
        this.bringYourDevice = "Bring your own device";
        this.retailPriceLabel = "Retail price: ";
        this.headingLabel = "Edit device options";
        this.colorLabel = 'Color:';
        this.capacityLabel = 'Capacity:';
        this.caseFinishLabel = 'Case material';
        this.caseColorLabel = 'Case Color:';
        this.bandSizeLabel = 'Band Size';
        this.bandTypeLabel = 'Band Type';
        this.bandColorLabel = 'Band Color:';
        this.billEstimatorHeadingText = 'Your estimated future bills';
        this.billEstimatorMessageText = 'Your upcoming bill will be different from your ongoing bills and may include any one-time and partial-month charges. See a breakdown of your bill estimates on the "Review order" page.';
        this.estDeliveryDateLabel = '<b>Estimated delivery:</b> Arrives ';
        this.shippingData = {
            expressShipping: 'Express shipping',
            overnight: 'Express shipping',
            premiumDeliveryShippingGroup: 'Express shipping',
            priority: 'Standard shipping',
            standardShipping: 'Standard shipping',
            thirdPartyShippingStandard: 'Standard shipping',
        };
        this.offersel = {
            consumerOffer: true,
            heading: 'Get an iPhone Xs 64GB for $0 when you buy it on a qualifying installment agreement',
            iconAltText: '<empty/>',
            iconImagePath: '<empty/>',
            iruOffer: true,
            legal: '/ecms/sharedcontent/en/legal/offercontent/12100005/jcr:content/desktoplegal/legalsharedcontent.json',
            legalPath: '/ecms/sharedcontent/en/legal/offercontent/6400020/jcr:content/desktoplegal/legalsharedcontent.json',
            legalPathIDP: {
                legalModalPath: ['/idpassets/fragment/legal/prod/legalcontent/wireless/offers/14200002/14200002_lm.cmsfeed.js'],
            },
            linkLabel: '<empty/>',
            linkType: 'modal',
            linkURL: '<empty/>',
            offerID: '12100005',
            promotionID: 'promo5490023',
            showOffer: true,
            smbOffer: false,
            strikethroughRestrictionText: 'Limited Time',
        };
        this.offers = {
            offers: [
                this.offersel,
            ],
        };
        this.hylaTradeInOffers = {
            offers: [
                this.offersel,
            ],
        };
        this.iruActivationFeeWaiver = 'Waived Activation Fee';
        this.plansListArray = {
            contentReference: [
                {
                    billCode: 'EPFL',
                    offerId: 'prod8490325',
                    planName: '25¢ per minute',
                },
            ],
        };
        this.plansList = [
            {
                billCode: 'EPFL',
                offerId: 'prod8490325',
                planName: '25¢ per minute',
            },
        ];
        this.ratePlanDisclaimerMessage = {
            SDGUNMEM: 'After 50GB, AT&T may slow data speeds when the network is busy.',
            SDGUNMSM: 'AT&T may slow speeds when the network is busy.',
            SDGUNPRM: 'After 100GB, AT&T may slow data speeds when the network is busy.',
        };
    }
    return WirelessCartSummaryCms;
}());
exports.WirelessCartSummaryCms = WirelessCartSummaryCms;
//# sourceMappingURL=WirelessCart.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessCart.cms.js
// module id = 347
// module chunks = 8